<template>
  <div>
    <a-card v-if="enterpriseAccountlist":bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-input  v-model="queryParam.enterpriseName"  />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="付款方式">
                <a-select v-model="queryParam.payType"  >
                  <a-select-option  v-for="type in resTypes" :key="type.code">{{type.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="市场负责人">
                <a-input  v-model="queryParam.marketPrincipal"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="最后一次充值日期">
                <a-range-picker
                  v-decorator="['finalRechargeTime']"
                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChange"
                  @ok="onOk"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" :style="{ textAlign: 'right' }">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="restdata()">清空</a-button>
            </a-col>
          </a-row>
          <a-divider/>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        :columns="columns"
        :data="loadData"
        style="margin-top: 24px"
        bordered
        :scroll="{ x: 1000 }"
      >
      <span slot="action" slot-scope="text, record">
        <a v-if='enterpriseAccountmodifyBalance' @click="Recharge2(record)">修改金额</a>
        <a-divider v-if='userType == 22&&enterpriseAccountrecharge' type="vertical"/>
         <a v-if="userType == 22&&enterpriseAccountrecharge" @click="Recharge9(record)">充值</a>
        <a-divider v-if="enterpriseAccountrefund" type="vertical" />
        <a v-if="enterpriseAccountrefund" @click="refund(record)">退款</a>
        <a-divider v-if="enterpriseAccountdetail" type="vertical" />
        <a v-if="enterpriseAccountdetail" @click="detailed(record)">明细</a>
      </span>
      </s-table>
      <a-modal
        title="修改金额"
        style="top: 20px;"
        :width="800"
        v-model="visible2"
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        :maskClosable="false"
      >
        <div class="table-page-search-wrapper">
          <a-form :form="form2" layout="inline">
            <a-form-item  label="修改金额">
              <a-input v-model="totalBalance"  />
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
      <accountrefund ref="model" @ok="$refs.table.refresh()"></accountrefund>
      <accountdetailed ref="model2" @ok="$refs.table.refresh()"></accountdetailed>
      <user-menu style="display: none" ref="model3" @ok="$refs.table.refresh()"></user-menu>
    </a-card>
    <no-authority v-else></no-authority>
  </div>

</template>

<script>
  import { checkPermission } from '@/utils/permissions'
  import NoAuthority from '../enterprise/NoAuthority'
  import moment from 'moment';
  import { STable } from '@/components'
  import { getDictMap } from '../../utils/dict'
  import { Recharge,changeMoney } from '@/api/enterprise/enterpriseAccount'
  import Accountrefund from './modules/Accountrefund.vue'
  import Accountdetailed from './modules/Accountdetailed.vue'
  import UserMenu from '@/components/tools/UserMenu.vue'
  import store from '@/store'
    export default {
        name: "enterpriseAccount",
      components:{
        STable,
        Accountrefund,
        Accountdetailed,
        UserMenu,
        NoAuthority
      },
      data(){
          return{
            // 充值
            enterpriseAccountrecharge: checkPermission('enterpriseAccountrecharge'),
            // 修改余额
            enterpriseAccountmodifyBalance: checkPermission('enterpriseAccountmodifyBalance'),
            // 查看列表
            enterpriseAccountlist: checkPermission('enterpriseAccount:query:list'),
            // 退款
            enterpriseAccountrefund	: checkPermission('enterpriseAccountrefund'),
            //明细
            enterpriseAccountdetail: checkPermission('enterpriseAccountdetail'),
            visible2:false,
            queryParam:{
              enterpriseId:this.$route.query.enterpriseId
            },
            userType:'',
            form:this.$form.createForm(this),
            form2:this.$form.createForm(this),
            resTypes:[],
            totalBalance:0,
            enterpriseId:'',
            loadData: parameter => {
              return Recharge(Object.assign(parameter, this.queryParam))
            },
            columns: [
              {
                title: '序号',
                dataIndex: 'num',
                align: 'center'
              },
              {
                title: '操作',
                dataIndex: 'action',
                scopedSlots: { customRender: 'action' },

              },
              {
                title: '企业名称',
                dataIndex: 'enterpriseName',
                align: 'center'
              },
              {
                title: '市场负责人',
                dataIndex: 'marketPrincipal',
                align: 'center'
              },
              {
                title: '付款方式',
                dataIndex: 'payType',
                align: 'center'
              },
              {
                title: '总充值金额',
                dataIndex: 'sumTotalAmount',
                align: 'center'
              },
              {
                title: '退款总金额',
                dataIndex: 'refund',
                align: 'center'
              },
              {
                title: '钱包余额',
                dataIndex: 'totalBalance',
                align: 'center'
              },
              {
                title: '近30天下单金额',
                dataIndex: 'orderAmount',
                align: 'center'
              },
              {
                title: '最后一次充值日期',
                dataIndex: 'finalRechargeTime',
                align: 'center'
              }
            ],
          }
      },
      mounted(){

      },
      methods:{

          //修改金额提交
        handleSubmit(e){
          e.preventDefault();
          changeMoney({
            enterpriseId:this.enterpriseId,
            totalBalance:this.totalBalance,
            remark:' '
          }).then(res=>{
            if (res.code === 0) {
              this.$message.success('修改成功')
              this.visible2 = false
              this.$refs.table.refresh()
            } else {
              this.$message.error('修改失败')
            }
          })
        },
        moment,
          //修改金额
        Recharge2(record){
          this.visible2=true
          this.enterpriseId=record.enterpriseId
          this.totalBalance=record.totalBalance
        },
        //充值
        Recharge9(){
          this.$refs.model3.information2()
        },
        restdata(){
          this.form.resetFields()
          this.queryParam={}
        },
        //最后一次充值日期
        onChange(date, dateString){
          this.queryParam.StartTime=dateString[0]
          this.queryParam.EndTime=dateString[1]
        },
        //退款
        refund(value){
          this.$refs.model.add(value)
        },
        //明细
        detailed(value){
          this.$refs.model2.add(value)
        },
      },
      async created(){
        this.userType=this.$store.getters.userType
        // 付款方式
        this.installTypeArr = await getDictMap('pay_type')
        this.installTypeArr.forEach((value, key) => {
          this.resTypes.push({ code: key, name: value })
        })
      }
    }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }

  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>